import { Pipe, PipeTransform } from '@angular/core';
import { SortDirection } from 'angular/utils/common-types';
import { Decimal } from 'decimal.js';

@Pipe({ name: 'pkpSort' })
export class SortPipe implements PipeTransform {
    transform(
        value: any[],
        options: {
            column?: string;
            order?: SortDirection;
        }
    ): any[] {
        if (
            !options ||
            !options.column ||
            !options.order ||
            options.order ===
                (SortDirection.NONE as any) /*whyever this is needed*/
        ) {
            return value.slice().sort((a, b) => b.id - a.id); // default sorted by newest first (highest id first)
        }
        let workingCopy = value.slice();
        workingCopy.sort((a, b) => {
            let aValue = this.getFieldValue(a, options.column);
            let bValue = this.getFieldValue(b, options.column);
            let sortValue = 0;
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                sortValue = aValue.localeCompare(bValue, 'en', {
                    sensitivity: 'base'
                });
            }
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                sortValue = aValue - bValue;
            }
            if (aValue instanceof Date && bValue instanceof Date) {
                sortValue = aValue.valueOf() - bValue.valueOf();
            }
            if (aValue instanceof Decimal && bValue instanceof Decimal) {
                sortValue = (aValue as Decimal).comparedTo(bValue as Decimal);
            }
            if (sortValue === 0) {
                // backup sorting for stableness
                return (
                    this.getFieldValue(b, 'id') - this.getFieldValue(a, 'id')
                ); // backup sorted by newest first (highest id first)
            }
            return options.order === SortDirection.ASC
                ? sortValue
                : sortValue * -1;
        });
        return workingCopy;
    }

    private getFieldValue(object: any, accessor: string) {
        const path = accessor.split('.');
        let obj = object;
        for (let i = 0; i < path.length; i++) {
            if (obj[path[i]]) {
                obj = obj[path[i]];
            } else {
                return null;
            }
        }
        return obj;
    }
}
